import styles from './ConstructionBadge.module.sass';

// Simple badge to show on under construction pages
export const ConstructionBadge = ({ message = "Under Construction" }) => {
  return (
    <div className={styles.constructionBadgeContainer}>
      <div className={styles.constructionBadge}>
        <svg className={styles.constructionBadgeIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 9V12M12 16H12.01M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        BETA
      </div>
      {message && <span className={styles.constructionMessage}>{message}</span>}
    </div>
  );
};

// Small badge for tab labels
export const ConstructionBadgeSmall = () => {
  return (
    <span className={styles.constructionBadgeSmall}>BETA</span>
  );
};

// Overlay for under construction features
export const ConstructionOverlay = () => {
  return (
    <div className={styles.constructionOverlay}>
      <div className={styles.constructionContent}>
        <svg className={styles.constructionIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 9V12M12 16H12.01M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <h3 className={styles.constructionTitle}>Under Construction</h3>
        <p className={styles.constructionDescription}>
          This feature is currently being developed and will be available soon.
        </p>
      </div>
    </div>
  );
};

// ConstructionSection wrapper component
export const ConstructionSection = ({ 
  isAvailable = false,
  children
}) => {
  return (
    <div style={{ position: 'relative' }}>
      {children}
      {!isAvailable && <ConstructionOverlay />}
    </div>
  );
};

export default ConstructionBadge;